/**
 * Service: reports
 */
angular.module('acme.common.service.reports', [
  'acme.common.service.reports.generator'
])
.service('ReportsService', [ '$q', '$timeout', 'ReportsGeneratorService', function($q, $timeout, ReportsGeneratorService) {

    return {

      metaFields: [],
      progress: {},
      partName: 'processing',

      init: function(config) {

        if (config.progress) {
          this.progress = config.progress;
        }

        return true;

      },

      parse: function(data, fields) {
        var i, ii,
            j, jj,
            field,
            r = [],
            cols = data.resultFieldList.length;

        if (cols > 0) {
          for (i=0,ii=data.resultFieldList[0].values.length; i<ii; i++) {
            field = {};
            for (j=0,jj=fields.length;j<jj;j++) {
              field[data.resultFieldList[j % cols].fieldName] = data.resultFieldList[j % cols].values[i];
            }
            r.push(field);
          }
        }

        return r;

      },

      summarize: function(fields, summary) {

        var self = this,
            rows = [],
            groups = {},
            q = $q.defer();

        this.progress.setValue(this.partName, 0);

        $timeout(function() {
          var o = self.summarizeFields(fields, summary.subTotals);
          rows = o.rows;
          groups = o.groups;

          self.progress.setValue(self.partName, 25);

          $timeout(function() {
            rows = self.summarizeSubtotals(rows, summary.subTotals);

            self.progress.setValue(self.partName, 50);

            $timeout(function() {
              groups = self.summarizeGroups(rows, groups);

              self.progress.setValue(self.partName, 75);

              q.resolve(groups);
              return true;
            }, 30);
            return true;
          }, 30);
          return true;
        }, 30);

        return q.promise;

      },

      summarizeFields: function(fields, subTotals) {
        var i, ii,
          j, jj,
          k, kk,
          field,
          subtotal,
          groupKey,
          fieldKey,
          highlightWidth,
          highlightColumns,
          rows = [],
          groups = {};

        var time = (new Date()).getTime();

        i = 0;
        ii = fields.length;
        while(i<ii) {
          rows.push(fields[i]);
          j = 0;
          jj = subTotals.length;
          while(j<jj) {
            if (i === subTotals[j].endIndex) {

              highlightWidth = 0;
              highlightColumns = {};

              subtotal = angular.copy(fields.slice(i)[0]); // Copy last row

              for (field in subtotal) {
                if (subtotal.hasOwnProperty(field)) {
                  subtotal[field] = '';
                }
              }

              k = 0;
              kk = subTotals[j].subtotalFields.length;
              while(k<kk) {
                subtotal[subTotals[j].subtotalFields[k].name] = subTotals[j].subtotalFields[k].value;
                highlightColumns[subTotals[j].subtotalFields[k].name] = true;
                highlightWidth++;
                k += 1;
              }

              subtotal.fields = [];
              k = 0;
              kk = subTotals[j].groupFields.length;
              while(k<kk) {
                subtotal[subTotals[j].groupFields[k].name] = subTotals[j].groupFields[k].value;
                subtotal.fields.push(subTotals[j].groupFields[k].name);
                k += 1;
              }

              subtotal.subtotal = true;
              groupKey = subTotals[j].primaryGroupField.name+':'+subTotals[j].primaryGroupField.value;
              fieldKey = subTotals[j].primaryGroupField.name+':'+subtotal[subTotals[j].primaryGroupField.name];
              subtotal[subTotals[j].primaryGroupField.name] = '';
              if (!groups[groupKey]) {
                groups[groupKey] = {
                  name: subTotals[j].primaryGroupField.name,
                  value: subTotals[j].primaryGroupField.value,
                  highlightColumns: highlightColumns,
                  highlightWidth: highlightWidth,
                  subtotals: 0,
                  startIndex: rows.length,
                  endIndex: 0,
                  values: []
                };
              }
              if (groupKey === fieldKey) {
                groups[groupKey].subtotals++;

                if (subTotals[j].startIndex < groups[groupKey].startIndex) {
                  groups[groupKey].startIndex = subTotals[j].startIndex;
                }
                if (subTotals[j].endIndex > groups[groupKey].endIndex) {
                  groups[groupKey].endIndex = subTotals[j].endIndex;
                }
              }
              rows.push(subtotal);
            }
            j += 1;
          }
          i += 1;
        }

        console.log('summarizeFields Time:' + ((new Date()).getTime() - time) + 'ms ' + (((new Date()).getTime() - time) / 1000) + 's');

        return {
          rows: rows,
          groups: groups
        };

      },

      summarizeSubtotals: function(rows, subTotals) {

        var i, ii,
            j, k,
            name,
            lastSubgroup = {},
            subgroup = 0;

        var time = (new Date()).getTime();

        // Visual cleanup for layout

        j = subTotals.length || 1;
        while(j -= 1) {
          k = subTotals[j].groupFields.length || 1;
          while(k -= 1) {
            lastSubgroup[subTotals[j].groupFields[k].name] = '';
          }
        }

        for (name in lastSubgroup) {
          if (lastSubgroup.hasOwnProperty(name)) {
            i = 0;
            ii = rows.length;
            while(i<ii) {
              if (lastSubgroup[name] !== rows[i][name]) {
                lastSubgroup[name] = rows[i][name];
              }else{
                rows[i][name] = '';
              }
              i += 1;
            }
          }
          subgroup += 1;
        }

        console.log('summarizeSubtotals Time:' + ((new Date()).getTime() - time) + 'ms ' + (((new Date()).getTime() - time) / 1000) + 's ');

        return rows;

      },

      summarizeGroups: function(rows, groups) {

        var i,
            key,
            field,
            lastEndIndex = 0,
            groupLength = 0;

        var time = (new Date()).getTime();

        for (key in groups) {
          if (groups.hasOwnProperty(key)) {
            console.log('ReportsService::summarize key', key);
            console.log('ReportsService::summarize groups', key, lastEndIndex, groups[key].startIndex + groups[key].endIndex + groups[key].subtotals + 1);
            groupLength = ((groups[key].endIndex - groups[key].startIndex) + groups[key].subtotals + 1);
            groups[key].values = rows.slice(lastEndIndex, lastEndIndex + groupLength);
            lastEndIndex = lastEndIndex + groupLength;
            console.log('ReportsService::summarize groups', 'length', groupLength, groups[key].values.length, 'start', groups[key].startIndex, 'end', groups[key].endIndex, 'sub', groups[key].subtotals);
            console.log('ReportsService::summarize groups', groups[key]);
            for (i = 0, ii = groups[key].values.length; i < ii; i++) {
              if (groups[key].values[i].subtotal) {
                //console.log('ReportsService::summarize groups',  groups[key].values[i], groups[key].values[i].fields[groups[key].values[i].fields.length - 1]);

                for (field in groups[key].values[i]) {
                  if (groups[key].values[i].hasOwnProperty(field)) {
                    if (groups[key].values[i].fields.indexOf(field) === -1) {
                      groups[key].values[i][field] = 'Subtotal';
                      break;
                    }
                  }
                }
              }
            }
          }
        }

        console.log('summarizeGroups Time:' + ((new Date()).getTime() - time) + 'ms ' + (((new Date()).getTime() - time) / 1000) + 's');

        return groups;

      },

      generate: function(props) {

        var r,
            q = $q.defer(),
            self = this;

        ReportsGeneratorService.init({
          progress: this.progress,
          type: props.type
        });

        ReportsGeneratorService.generate(props.report).then(function(markup) {
          r = markup;

          self.progress.setValue(self.partName, 100);
          q.resolve(r);
        });

        return q.promise;

      },

      getColumns: function(data) {
        var i, ii,
            field,
            column,
            columns = [];

        for (i=0,ii=data.length;i<ii;i++) {

          field = this.findMetadataField(data[i].fieldName).field;

          column = {
            field: field.name,
            displayName: field.displayName
          };

          column.type = field.dataType.toLowerCase();

          columns.push(column);

        }

        return columns;
      },

      getTotals: function(totals) {
        var i,
            ii = totals.length,
            r = (ii > 0) ? {} : false;

        for (i=0,ii=totals.length;i<ii;i++) {
          r[totals[i].name] = totals[i].value;
        }

        return r;
      },

      isDateField: function(name) {
        return false;
      },

      isFieldType: function(name, type) {
        var i, ii,
            r = false,
            fields = this.metaFields;

        for (i=0,ii=fields.length;i<ii;i++) {
          if (fields[i].name.toLowerCase() === name.toLowerCase()) {
            r = (fields[i].dataType.toLowerCase() === type.toLowerCase());
            break;
          }
        }

        return r;
      },

      findGroupField: function(name, queryExpression) {
        var i, ii,
          r = false;

        console.log('getGroupField', name, queryExpression);

        for (i=0,ii=queryExpression.groupFields.length;i<ii;i++) {
          if (queryExpression.groupFields[i].fieldName === name) {
            r = {
              index: i,
              field: queryExpression.groupFields[i]
            };
            break;
          }
        }

        return r;
      },

      findMetadataField: function(name) {
        var i, ii,
            r = false,
            fields = this.metaFields;

        for (i=0,ii=fields.length;i<ii;i++) {
          if (fields[i].name.toLowerCase() === name.toLowerCase()) {
            r = {
              index: i,
              field: fields[i]
            };
            break;
          }
        }

        return r;
      },

      findMetadataFieldsByType: function(type, prop) {
        var i, ii,
            j, jj,
            types = [],
            r = false,
            fields = this.metaFields;

        if (type instanceof Array) {
          types = type;
        }else if (typeof(type) === 'string') {
          types.push(type);
        }

        for (i=0,ii=fields.length;i<ii;i++) {
          for (j=0,jj=types.length;j<jj;j++) {
            if (fields[i].dataType.toLowerCase() === types[j].toLowerCase()) {
              if (r === false) {
                r = [];
              }
              if (prop && fields[i].hasOwnProperty(prop)) {
                // Get only the property
                r.push(fields[i][prop]);
              } else {
                //Get the entire field
                r.push(fields[i]);
              }
              break;
            }
          }
        }

        return r;
      }

    };

}]);
